export default __webpack_public_path__ + "static/digital-transformation-peerbits-120dec50589e993232a58e7b66ebdf21.png";